'use client';

import clsx from 'clsx';
import s from './Hero.module.scss';

interface CarpetCardProps {
  text: string;
  ariaLabel: string;
}

export default function CarpetCard({ text, ariaLabel }: CarpetCardProps) {
  return (
    <div className={clsx(s.card, s.artistCard)}>
      <video
        src="/video/carpetman-video-sm.mp4"
        width={216}
        height={201}
        autoPlay
        loop
        muted
        playsInline
        controls={false}
        poster="/img/artists/carpetman-poster.webp"
        aria-label={ariaLabel}
        onContextMenu={(e) => e.preventDefault()}
      />
      <p>{text}</p>
    </div>
  );
}
